export default "__VITE_ASSET__BQwjb6TF__"